export default __webpack_public_path__ + "static/media/arrow-select-down.db11a4ed.svg";